import { Collection } from '@share/interfaces';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import loadable from '@loadable/component';
import styled from '@emotion/styled';

const SkeletonImage = loadable(() => import('@com/utils/SkeletonImage'));

const Body = styled.div`
  transition: all 0.4s ease;
  :hover {
    transform: scale(1.03);
  }
`;

function MiniCollectionCard({ item }: { item: Collection }) {
  /* Define state / hook */
  const { t, i18n } = useTranslation();

  /* Custom Data Object for render or other usages */
  const collectionIdentifier = item.custom_url || item.address;

  /* Render control function / logic */

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Render */
  return (
    <Body>
      <div className="sc-card-collection style-2 home2">
        <Link
          to={`/collection/${item.network_chain_id}/${collectionIdentifier}`}
        >
          <div className="card-media-h6">
            <SkeletonImage
              alt="Feature Image"
              ratio={4 / 3}
              size={[512]}
              src={item.feature_image}
            />
          </div>
        </Link>
        <div className="card-bottom">
          <div className="author w-100 d-flex">
            <div className="sc-author-box style-2">
              <div className="author-avatar">
                <SkeletonImage
                  className="avatar"
                  ratio={1}
                  size={[64, 128]}
                  src={item.logo_image}
                  width={50}
                />
              </div>
            </div>
            <div className="content w-75">
              <div className="text-truncate fs-16 font-weight-bold">
                <Link
                  // Character 'g' cannot display clearly
                  style={{ lineHeight: '120%' }}
                  to={`/collection/${item.network_chain_id}/${collectionIdentifier}`}
                >
                  {item.name}
                </Link>
              </div>
              <div className="infor text-truncate">
                <span>{t('collection.createAt')}</span>
                <span className="ml-2">
                  {new Date(item.created_at).toLocaleString(i18n.language)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Body>
  );
}

export default MiniCollectionCard;
